import { gql } from '../../__gql__/gql';

export const TRANSLATIONS = gql(`
  query Translations($app: String!, $lng: String!) {
    translations(app: $app, lng: $lng) {
      content
      languageCodes
    }
  }
`);
